import { merge } from 'ramda';
import { TActions } from '../../../types/actions';
import { CHANGE_USER, CHANGE_USER_GEO } from './actions';
import { IUserState } from './types';

export const initialState = {};

export function user(state: IUserState, action: TActions) {
  switch (action.type) {
    case CHANGE_USER:
      return merge(state, action.payload);

    case CHANGE_USER_GEO:
      return merge(state, { geo: action.payload });

    default:
      return state || initialState;
  }
}
